import common from './common/en';
import exhibitors from './exhibitors/en';
import visitors from './visitors/en';

export default {
  common,
  exhibitors,
  visitors,
};
